import { type IParamsSendFrom } from 'entities/SendFrom'
import type { IResponseFilterSegment } from 'entities/Segment'
import {
  type IChatbotFilters,
  type ChatbotInstructionType,
  type ChatbotStatus,
  type IChatbotAnalyticBase,
  type IChatbotAnalyticQuietHoursItem,
  type IChatbotConversationStatus,
  type IChatbotData,
  type IChatbotMessage,
  type IChatbotActionSettings,
  type IChatbotSettings,
  type IChatbotField,
  type IAgentFirstStepPayload,
} from '../model/type'

export type { IChatbotPayload } from '../model/type'

export enum ChatbotListParams {
  Name = 'filters[name]',
  Status = 'filters[status]',
}

export type IParamsGetChatbotList = {
  limit: number | null
  page: number
  [ChatbotListParams.Name]?: string
  [ChatbotListParams.Status]?: ChatbotStatus
}

export type IResponseChatbotList = {
  data: IChatbotFullData[]
  meta: IChatbotListPagination
}

export type IChatbotListPagination = {
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export type IChatbotFullData = IChatbotData & { id: number }

export type IResponseUpdateChatbotStatus = IChatbotFullData

export type IResponseDeleteChatbot = {
  status: string
  message: string
}

export enum ChatbotAnalyticListFilter {
  Status = 'filters[status]',
  From = 'filters[from]',
  To = 'filters[to]',
}

export type IParamsGetChatbotAnalyticList = {
  id: number
  limit: number | null
  page: number
  search?: string
  [ChatbotAnalyticListFilter.Status]?: IChatbotConversationStatus | null
  [ChatbotAnalyticListFilter.From]?: Date | null | string
  [ChatbotAnalyticListFilter.To]?: Date | null | string
}

export type IChatbotAnalyticListItemApi = IChatbotAnalyticBase | IChatbotAnalyticQuietHoursItem

export type IChatbotListPaginationLinks = {
  first: string
  last: string
  prev: string | null
  next: string | null
}

export type IResponseChatbotAnalyticList = {
  data: IChatbotAnalyticListItemApi[]
  meta: IChatbotListPagination
  links?: IChatbotListPaginationLinks
}

export type IParamsEnrollContactsInChatbot = {
  chatbot_id: number
  contact_ids: number[]
  apply_filters: boolean
  send_from?: IParamsSendFrom | null
}

export type IParamsEnrollContactsByFiltersInChatbot = {
  inbox_id?: number
  apply_filters: boolean
  contact_filters?: IResponseFilterSegment[]
  apply_to_all?: boolean
  search?: string
}

export type IChatbotInstructionTemplate = {
  type: ChatbotInstructionType
  instruction: string
}

export type IResponseChatbotInstruction = {
  templates: IChatbotInstructionTemplate[]
}

export type IParamsValidateAgentByStep = {
  name?: string
  filters?: IChatbotFilters | null
  send_from?: IParamsSendFrom | null
  first_message?: IChatbotMessage | null
  settings?: IChatbotSettings | null
  success_actions?: IChatbotActionSettings[] | null
  fallback_actions?: IChatbotActionSettings[] | null
  qualified_actions?: IChatbotActionSettings[] | null
  disqualified_actions?: IChatbotActionSettings[] | null
  fields?: IChatbotField[]
  knowledge_base_documents?: IAgentFirstStepPayload['knowledge_base_documents']
}

export type IResponseChatbotValidation = {
  valid: boolean
}

export type IParamsEnhancePrompt = {
  prompt: string
  chatbotType: number
  usesKnowledgeBase: boolean
  chatbotId: number
}

export type IResponseEnhancePrompt = {
  improvedPrompt: string
  suggestions: { text: string }[]
}
